module.exports = __webpack_public_path__ + "static/download/poster_RGB.jpeg?464d8889";